/**
 * Root-level route constants — pages registered directly on `app.routes.ts`.
 */
export abstract class AppRoutesConst {

    /** The route page segment for the Not Found page. */
    public static readonly NOT_FOUND_ROUTE_PAGE = 'not-found';

    /** The full absolute route link for the Not Found page. */
    public static readonly NOT_FOUND_ROUTE_LINK = `/${AppRoutesConst.NOT_FOUND_ROUTE_PAGE}`;

}
